import React from "react";
import { GoCalendar } from "react-icons/go";

const date = new Date();
var months = [
  "يناير",
  "فبراير",
  "مارس",
  "ابريل",
  "مايو",
  "يونيو",
  "يوليو",
  "اغسطس",
  "سبتمبر",
  "اكتوبر",
  "نوفمبر",
  "ديسمبر",
];

var days = [
  "الأحد",
  "الأثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت",
];
const year = date.getFullYear();
const month = months[date.getMonth()];
const day = days[date.getDay()];
const number = date.getDate();
const newDate = day + " " + number + " " + month + " " + year;

export const DateTime = () => {
  return (
    <div className="d-flex d-sm-flex flex-sm-row align-items-center justify-contents-center pr-1">
      <GoCalendar size="1.2em" />
      <small className="mb-0 mr-2">{newDate}</small>
    </div>
  );
};

export default DateTime;
